import React from 'react';
import { Modal, Text, Button, Group, Stack, Avatar } from '@mantine/core';
import { PersonBetter } from '../../types/Person';

interface RemovePersonModalProps {
    opened: boolean;
    onClose: () => void;
    person: PersonBetter;
    onRemove: (person: PersonBetter) => void;
}

export function RemovePersonModal({ opened, onClose, person, onRemove }: RemovePersonModalProps) {
    const handleRemove = () => {
        onRemove(person);
        onClose();
    };

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Remove Person"
            size="md"
        >
            <Stack align="center">
                <Avatar
                    src={person.profile_url}
                    radius="xl"
                    size="xl"
                    alt={`${person.first} ${person.last}`}
                />
                
                <Text size="lg" fw={500}>
                    {person.first} {person.last}
                </Text>
                
                <Text ta="center">
                    Are you sure you want to remove this person from your family tree?
                    This action cannot be undone and will remove all relationships associated with this person.
                </Text>
                
                <Group justify="center" mt="md">
                    <Button variant="outline" onClick={onClose}>Cancel</Button>
                    <Button color="red" onClick={handleRemove}>Remove</Button>
                </Group>
            </Stack>
        </Modal>
    );
}
